import React from 'react'
import { StyledQuestionBox, StyledQuestionBoxHeader } from '../../../styles'
import PreparedQuestionCardDropDownMenu from './PreparedQuestionCardDropDownMenu'
import { useDispatch } from 'react-redux'
import { StyledBox } from './styles'
import { type Question } from '../../../types'
import { getEditableQuestion, getSelectedQuestion } from '../../../../../store/slices/SurveyTemplateSlice/selectors'
import { type ISurveySection, setEditableQuestion, updateQuestionInSection } from '../../../../../store/slices/SurveyTemplateSlice'
import { Box } from '@mui/material'
import SchoolApprovedBadge from '../SchoolApprovedBadge'
import { useLocation } from 'react-router-dom'
import ROUTES from '../../../../../consts/paths'

interface PreparedQuestionCardWrapperProps {
  children: JSX.Element
  question: Question
  index?: number
  questionNumber?: number
  sectionIndex: number
  totalQuestionInSection: number
  section: ISurveySection
  isEditable?: boolean
  isSurveyTemplate?: boolean
}

const PreparedQuestionCardWrapper: React.FC<PreparedQuestionCardWrapperProps> = ({ questionNumber, children, question, index = 0, sectionIndex, totalQuestionInSection, section, isEditable, isSurveyTemplate = false }): JSX.Element => {
  const dispatch = useDispatch()
  const editableQuestion = getEditableQuestion()
  const selectedQuestion = getSelectedQuestion()
  const location = useLocation()
  const isAcademicRoute = location.pathname.includes(ROUTES.ACADEMIC_UNIT_ADDED_QUESTIONS)
  const handleEditableQuestion = (): void => {
    if (editableQuestion == null && !selectedQuestion && isEditable !== false) {
      dispatch(setEditableQuestion({ question, questionIndex: index, sectionIndex }))
    }
  }

  const handleChangeSchoolApproved = (isSchoolApproved: boolean): void => {
    if (isSurveyTemplate && index !== undefined) {
      dispatch(updateQuestionInSection({
        surveySectionId: section.surveySectionId,
        questionIndex: index,
        updatedQuestion: { ...question, isSchoolApproved }
      }))
    }
  }

  const showSchoolApprovedBadge = isEditable === false || isSurveyTemplate || isAcademicRoute

  return (
    <StyledQuestionBox id={`${question.itemId}`}>
      <StyledQuestionBoxHeader>
        Question {questionNumber}
        <Box display='flex' flexDirection='row' alignItems='center'>
          {showSchoolApprovedBadge &&
            <SchoolApprovedBadge
              isSurveyTemplate={isSurveyTemplate}
              onClick={handleChangeSchoolApproved}
              isApproved={question.isSchoolApproved}
            />
          }
          <PreparedQuestionCardDropDownMenu question={question} questionIndex={index} sectionIndex={sectionIndex} totalQuestionInSection={totalQuestionInSection} section={section}/>
        </Box>
      </StyledQuestionBoxHeader>
      <StyledBox onClick={handleEditableQuestion}>
        {children}
      </StyledBox>
    </StyledQuestionBox>
  )
}

export default PreparedQuestionCardWrapper
